import { Colors, Lightning, Utils } from '@lightningjs/sdk'

export default class VideoCover extends Lightning.Component {
  static _template() {
    return {
      w: 190,
      h: 229,
      Wrapper: {
        w: 190,
        h: 225,
        x: 2,
        y: 3,
        clipping: true,
        rect: true,
        color: 0xffffffff,
        blend: 0,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: [5, 5, 0, 0],
          stroke: 1,
          fill: 1,
          fillColor: 0xffffffff,
        },
        VideoImage: { w: 190, h: 190, src: this.bindProp('videoPlaceholder') },
        BottomBlock: {
          w: 190,
          h: 39,
          y: 188,
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: [0, 0, 5, 5],
            stroke: 0,
            fill: 1,
            fillColor: Colors('onAir').get(),
          },
        },
        VideoIcon: {
          w: 27,
          h: 17,
          x: 190 / 2,
          y: 199,
          mountX: 0.5,
          src: Utils.asset('images/playerbuttons/videoPlayerIcon.png'),
        },
      },
      Border: {
        w: 190,
        h: 227,
        x: 2,
        y: 3,
        zIndex: 10,
        alpha: 0,
        Arround: {
          w: 190,
          h: 227,
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 5,
            stroke: 2,
            strokeColor: 0xffffffff,
            fill: 0,
            fillColor: 0x00000000,
          },
        },
        Between: { w: 190, h: 2, y: 189, rect: true, color: 0xffffffff },
      },
    }
  }

  set video(videoData) {
    this._vData = videoData

    const videoPlaceholder = this._vData.thumb

    this.patch({ videoPlaceholder })
  }

  get item() {
    return this._vData
  }

  _focus() {
    this.tag('Border').patch({
      smooth: {
        alpha: [1, { duration: 0.2, delay: 0.1, timingFunction: 'ease-in' }],
      },
    })
  }

  _unfocus() {
    this.tag('Border').patch({
      smooth: {
        alpha: [0, { duration: 0.2, delay: 0.1, timingFunction: 'ease-in' }],
      },
    })
  }
}
